import {
	SP_ORDER_JOBS_LIST_FILTERED,
	SP_ORDER_JOBS_LIST_FILTERED_SUCCESS,
	SP_ORDER_JOBS_LIST_FILTERED_ERROR,
} from "../actions/spOrderJobs";
import spOrderJobsService from '@/services/spOrderJobs';

const state = {
};

const getters = {
};

const actions = {
	[SP_ORDER_JOBS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.spOrderId) {
			requestData.spOrderIdFilter = data.tableProps.inputFilter.spOrderId;
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDER_JOBS_LIST_FILTERED);
			spOrderJobsService.listFiltered(requestData)
				.then(responseData => {
					commit(SP_ORDER_JOBS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDER_JOBS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	}
};

const mutations = {
	[SP_ORDER_JOBS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[SP_ORDER_JOBS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDER_JOBS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};